import React, { useRef } from "react";
import { FaSitemap, FaUserTie } from "react-icons/fa";

export const PORTALS = {
  COCOUNSEL: "cocounsel",
  COORDINATOR: "coordinator",
};

const OPTIONS = [
  { value: PORTALS.COCOUNSEL, labelKey: "cocounsel", Icon: FaUserTie },
  { value: PORTALS.COORDINATOR, labelKey: "coordinator", Icon: FaSitemap },
];

const PortalSelector = ({ canViewCoordinator, value, onChange, labels }) => {
  const optionRefs = useRef([]);

  if (!canViewCoordinator) {
    return <span className="clients-title-kicker">{labels.cocounsel}</span>;
  }

  const selectedIndex = Math.max(
    OPTIONS.findIndex((option) => option.value === value),
    0,
  );

  const select = (index) => {
    const next = OPTIONS[index];
    optionRefs.current[index]?.focus();
    if (next.value !== value) onChange(next.value);
  };

  const handleKeyDown = (event) => {
    let nextIndex;
    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        nextIndex = (selectedIndex + 1) % OPTIONS.length;
        break;
      case "ArrowLeft":
      case "ArrowUp":
        nextIndex = (selectedIndex - 1 + OPTIONS.length) % OPTIONS.length;
        break;
      case "Home":
        nextIndex = 0;
        break;
      case "End":
        nextIndex = OPTIONS.length - 1;
        break;
      default:
        return;
    }
    event.preventDefault();
    select(nextIndex);
  };

  return (
    <div
      className="portal-switch"
      role="radiogroup"
      aria-label={labels.selector}
      onKeyDown={handleKeyDown}
      style={{ "--portal-switch-index": selectedIndex }}
    >
      <span className="portal-switch-highlight" aria-hidden="true" />
      {OPTIONS.map(({ value: optionValue, labelKey, Icon }, index) => {
        const checked = index === selectedIndex;
        return (
          <button
            key={optionValue}
            ref={(node) => {
              optionRefs.current[index] = node;
            }}
            type="button"
            role="radio"
            aria-checked={checked}
            tabIndex={checked ? 0 : -1}
            className={`portal-switch-option${checked ? " is-selected" : ""}`}
            onClick={() => select(index)}
          >
            <Icon className="portal-switch-icon" aria-hidden="true" focusable="false" />
            <span className="portal-switch-label">{labels[labelKey]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PortalSelector;
